module.exports = __webpack_public_path__ + "static/media/background.medquarters.a6b0f569.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.medquarters.png
// module id = 555
// module chunks = 0